<h2 mat-dialog-title>Providers</h2>

<mat-dialog-content>
  <div class="mb-3">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Search Provider</mat-label>
      <input
        matInput
        [(ngModel)]="searchText"
        (input)="onSearch()"
        placeholder="Search by name, NPI, Tax ID, License"
      />
    </mat-form-field>
  </div>

  <div class="provider-table-wrapper">
    <table class="table table-bordered table-hover mb-0">
      <thead>
      <tr>
        <th>Name</th>
        <th>NPI</th>
        <th>Tax ID</th>
        <th>License</th>
        <th>Address</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let provider of filteredProviders">
        <td>{{ provider.firstName }} {{ provider.lastName }}</td>
        <td>{{ provider.npi }}</td>
        <td>{{ provider.taxId }}</td>
        <td>{{ provider.license }}</td>
        <td>{{ provider.addressLine1 }} {{ provider.addressLine2 }} {{ provider.city }} {{ provider.state }} {{ provider.zipCode }}</td>
      </tr>

      <tr *ngIf="!filteredProviders.length">
        <td colspan="5" class="text-center text-muted">No providers found</td>
      </tr>
      </tbody>
    </table>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="close()">Close</button>
</mat-dialog-actions>
